import { render, staticRenderFns } from "./view.vue?vue&type=template&id=3b45bfbe&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b45bfbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b45bfbe')) {
      api.createRecord('3b45bfbe', component.options)
    } else {
      api.reload('3b45bfbe', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=3b45bfbe&scoped=true&", function () {
      api.rerender('3b45bfbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/securityCheckMgr/securityCheck/view.vue"
export default component.exports